import React, { useEffect, useState } from 'react';
import style from './About.module.css';
import '../../components/headersStyling.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loading from '../../components/Loading/Loading';
import { getAboutSettings, getBenefits, getTestmonials } from '../../Api/aboutApis';
import BlogsSlider from './../../components/blogSLider/index';
import BrandsSlider from './../../components/brands/brandsSlider';
import { filterLanguage } from './../../utilities/filterFunction';
import { getHomeHeaders } from '../../Api/homeApis';
import { getBrands } from '../../Api/commonApis';
import parse from 'html-react-parser';
import { basename } from './../../configiration/config';
import { imgResize } from './../../utilities/imageResize';

function About() {
    let navigate = useNavigate();
    const { pathname } = useLocation();
    const [aboutData, setAboutData] = useState({});
    const [brands, setbrands] = useState([]);
    const [benefits, setBenefits] = useState([]);
    const [testmonials, setTestmonials] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    // get About us
    useEffect(() => {
        getAboutSettings().then((res) => {
            let about = { ...aboutData }
            about = res.data.data
            setAboutData(about);
            setLoading(false);
        }).catch(()=>{
            setLoading(false);
        })

        getBenefits().then((res)=>{
            let Benefits = [...benefits]
            Benefits = res.data.data
            setBenefits(Benefits)
        })
        // eslint-disable-next-line
    }, []);

    const [blogsHeaders,setblogsHeaders]=useState()

    useEffect(() => {
      // get home Data
      getHomeHeaders().then((res) => {
       let homeData = res.data.data;
        setblogsHeaders(homeData.home_blog_section)
      })
      getBrands().then((res)=> {
        let brand=[...brands]
        brand= res.data.data
        setbrands(brand)
      })
      // eslint-disable-next-line
    }, []);

    useEffect(() => {
        // get all Testmonials
        getTestmonials().then(response => {
            if (response.data.status === true) {
                let testmon = [...testmonials]
                testmon = response.data.data
                setTestmonials(testmon);
            }
        })
        // eslint-disable-next-line
    }, []);

    return (
        <div className={`${style.aboutComponent}`}>
            {/* START OF HEADER SECTION */}
            {aboutData !== null && aboutData.image ? 
                <div className={`myHeader d-flex align-items-center justify-content-center`} style={{ backgroundImage: `url(${imgResize(aboutData.image,1920,0)} )`}}>
                    <div className={`myHeaderContent`}>
                        <h1>{t('about-us')}</h1>
                        <div className='headerNav'><span className='homeWord' onClick={() => { navigate(`${process.env.REACT_APP_BASENAME}/`) }}>{t('home')}</span> / {t('about-us')}</div>
                    </div>
                </div>
                :
                <div className={`myHeader d-flex align-items-center justify-content-center`} >
                    <div className={`myHeaderContent`}>
                        <h1>{t('about-us')}</h1>
                        <div className='headerNav'>
                            <span className='homeWord' onClick={() => { navigate(`${basename}/`) }}>{t('home')}</span> / {t('about-us')}
                        </div>
                    </div>
                </div>
            } 
            {/* END OF HEADER SECTION */}
            {loading && <Loading width='100px' height='100px' />}

            <div className={`${style.aboutDesc} my-5`}>
                <h2 className={style.sectionTitle}>{aboutData && aboutData.locales && filterLanguage(aboutData.locales)[0].title}</h2>
                <div className={style.sectionSubTitle}>{aboutData && aboutData.locales && parse(filterLanguage(aboutData.locales)[0].description)}</div>
            </div>

            {/* START OF ABOUT INFO SECTION */}
            <div className={`${style.aboutInfo} d-flex align-items-center justify-content-center py-4 my-5`}>
                <div className={`${style.itemsContainer} row`}>
                    {benefits && benefits.map((benefit) => {
                        let selectedBenefit=filterLanguage(benefit.locales)
                        return (
                            <div key={benefit.slug} className={`${style.infoItem} col-md-6 col-lg-4 `}>
                                <div className={`${style.icon}`}>
                                    <img src={imgResize(benefit.image,30,0)} alt='...'/>
                                </div>
                                <h4>{selectedBenefit.length >0 && selectedBenefit[0].title}</h4>
                                <div className={style.benefitPargraph}>{selectedBenefit.length >0 && selectedBenefit[0].description}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
            {/* END OF ABOUT INFO SECTION */}

            {/* START OF TODO SECTION */}
                <BlogsSlider blogHeader={blogsHeaders} hideBackLayer={true}/>
            {/* END OF TODO SECTION */}

            {/* START OF REVIEWS SECTION */}
            {testmonials && testmonials.length > 0 ?
                <div className={`${style.reviews} `}>
                    <div >
                        <div id="carouselExampleControls" className={`${style.reviewsCarousel} carousel slide`} data-bs-ride="carousel">
                            <div className="carousel-inner">
                                {testmonials.map((test, i) => {
                                    let selectedTestmonial=filterLanguage(test.locales)
                                    return (
                                        <div key={test.slug} className={`carousel-item ${i === 0 && 'active'}`} data-bs-interval="2500">
                                            <div className={`${style.review}`}>
                                                <h2 className={`${style.reviewTitle}`}>"{selectedTestmonial && selectedTestmonial.length && selectedTestmonial[0].title}"</h2>
                                                <p className={`${style.reviewBody}`}>
                                                {selectedTestmonial && selectedTestmonial.length && selectedTestmonial[0].description}
                                                </p>
                                                <span className={`${style.reviewer}`}>{selectedTestmonial && selectedTestmonial.length && selectedTestmonial[0].name}</span>
                                            </div>
                                        </div>
                                    )
                                })}

                            </div>
                            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                                <span className={`${style.carouselPrevBtn} carousel-control-prev-icon`} aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                                <span className={`${style.carouselNextBtn} carousel-control-next-icon`} aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                </div>
                : <div></div>
            }
            {/* END OF REVIEWS SECTION */}

            {/* START OF BRANDS SECTION */}
          <BrandsSlider brands={brands}/>
            {/* END OF BRANDS SECTION */}
        </div>
    )
}

export default About